// Typelizer digest ce1720c2bdec53365dc4c6108a93d97d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/teams */
  index: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams', params, options),
    method: 'get',
  }),

  /** POST /educators/teachers/:teacher_id/teams */
  create: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams', params, options),
    method: 'post',
  }),

  /** GET /educators/teachers/:teacher_id/teams/new */
  new: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/new', params, options),
    method: 'get',
  }),

  /** GET /educators/teachers/:teacher_id/teams/:id/edit */
  edit: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:id/edit', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/teams/:id */
  update: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /educators/teachers/:teacher_id/teams/:id */
  destroy: (
    params: { teacherId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:id', params, options),
    method: 'delete',
  }),
}
